export const KBD_ICONS = new Map([
  ["KeyA", "a"],
  ["KeyB", "b"],
  ["KeyC", "c"],
  ["KeyD", "d"],
  ["KeyE", "e"],
  ["KeyF", "f"],
  ["KeyG", "g"],
  ["KeyH", "h"],
  ["KeyI", "i"],
  ["KeyJ", "j"],
  ["KeyK", "k"],
  ["KeyL", "l"],
  ["KeyM", "m"],
  ["KeyN", "n"],
  ["KeyO", "o"],
  ["KeyP", "p"],
  ["KeyQ", "q"],
  ["KeyR", "r"],
  ["KeyS", "s"],
  ["KeyT", "t"],
  ["KeyU", "u"],
  ["KeyV", "v"],
  ["KeyW", "w"],
  ["KeyX", "x"],
  ["KeyY", "y"],
  ["KeyZ", "z"],
  ["Digit0", "0"],
  ["Digit1", "1"],
  ["Digit2", "2"],
  ["Digit3", "3"],
  ["Digit4", "4"],
  ["Digit5", "5"],
  ["Digit6", "6"],
  ["Digit7", "7"],
  ["Digit8", "8"],
  ["Digit9", "9"],
  ["Period", "."],
  ["Comma", ","],
  ["Semicolon", ";"],
  ["Quote", "'"],
  ["BracketLeft", "["],
  ["BracketRight", "]"],
  ["Backslash", "\\"],
  ["Slash", "/"],
  ["Minus", "-"],
  ["Equal", "="],
  ["Backquote", "`"],
  ["IntlBackslash", "¦"],
  ["IntlRo", "ろ"],
  ["IntlYen", "¥"],
  ["IntlHash", "#"],
  ["BracketLeft", "["],
  ["BracketRight", "]"],
  ["NumLock", "⇭"],
  ["ScrollLock", "⇳"],
  ["Backspace", "⌫"],
  ["Delete", "⌦"],
  ["Enter", "↵"],
  ["Space", "␣"],
  ["Tab", "⇥"],
  ["ArrowLeft", "←"],
  ["ArrowRight", "→"],
  ["ArrowUp", "↑"],
  ["ArrowDown", "↓"],
  ["ShiftLeft", "⇧"],
  ["ShiftRight", "⇧"],
  ["ControlLeft", "Ctrl"],
  ["ControlRight", "Ctrl"],
  ["AltLeft", "Alt"],
  ["AltRight", "Alt"],
  ["MetaLeft", "⌘"],
  ["MetaRight", "⌘"],
  ["CapsLock", "⇪"],
  ["Escape", "Esc"],
  ["F1", "F1"],
  ["F2", "F2"],
  ["F3", "F3"],
  ["F4", "F4"],
  ["F5", "F5"],
  ["F6", "F6"],
  ["F7", "F7"],
  ["F8", "F8"],
  ["F9", "F9"],
  ["F10", "F10"],
  ["F11", "F11"],
  ["F12", "F12"],
  ["PrintScreen", "PrtSc"],
  ["Pause", "Pause"],
  ["Insert", "Ins"],
  ["Home", "Home"],
  ["End", "End"],
  ["PageUp", "PgUp"],
  ["PageDown", "PgDn"],
  ["ContextMenu", "Menu"],
]);
